<template>

    <button :type="type"
        class="inline-flex items-center
            border-transparent
            tracking-widest
            active:bg-opacity-90
            outline-none
            disabled:opacity-25
            transition
            py-4 px-4 bg-blue rounded-xl text-white font-nexa text-base leading-none hover:bg-dark-blue">
        <slot></slot>
    </button>

</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    })
</script>
